import { DefaultButton, Stack, StackItem } from '@fluentui/react';
import React from 'react';

import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import MobileAttachments, { MobileAttachmentsState } from './MobileAttachments';
import {
	IEmailStoredFilingInfo,
	IInitializationContext,
	IOutlookAppCommands,
	OutlookMessageMode,
} from '../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';
import { IEntityTypeUserInfo, IUserConfigPackage } from '../API';

export interface IMailProps {
	state: MobileAttachmentsHarnessState;
}

class MobileAttachmentsHarness extends React.Component<IMailProps, {}> {
	render(): React.ReactNode {
		return (
			<Stack horizontal style={{ border: '1px solid black', margin: 50 }}>
				<Stack>
					<DefaultButton
						onClick={() => {
							if (this.props.state.itemChangedCallback)
								this.props.state.itemChangedCallback();
						}}
					>
						Change selection
					</DefaultButton>
				</Stack>

				<StackItem grow style={{ height: 1000 }}>
					<div
						dangerouslySetInnerHTML={{ __html: this.props.state.currentText }}
					></div>
					&nbsp;
				</StackItem>

				<StackItem style={{ width: 320, height: 1000 }}>
					<MobileAttachments state={this.props.state.mail} />
				</StackItem>
			</Stack>
		);
	}
}

export default observer(MobileAttachmentsHarness);

export class MobileAttachmentsHarnessState {
	public currentText: string = '';
	public mail: MobileAttachmentsState;
	private userConfig: IUserConfigPackage;
	public itemChangedCallback?: () => void;
	public itemInfoChangedCallback?: () => void;

	constructor(userConfig: IUserConfigPackage, mode: OutlookMessageMode) {
		this.userConfig = userConfig;
		makeAutoObservable(this);

		let commands: IOutlookAppCommands = {
			getInitializationContext: () => {
				return Promise.resolve({
					activity: 'test-activity',
				} as IInitializationContext);
			},
			getDragDropManager: () => {
				throw new Error('Method not implemented.');
			},
			onItemChanged: (callback: () => void) => {
				this.itemChangedCallback = callback;
			},
			onItemInfoChanged: (callback: () => void) => {
				this.itemInfoChangedCallback = callback;
			},
			getAttachments: () => Promise.resolve([]),
			getAttachmentContent: (id) => Promise.resolve(undefined),
			getDraftItemId: () => Promise.resolve(''),
			getMessageMode: () => mode,
			getSubject: () => Promise.resolve('00034'),
			setSubject:(sub:string) => Promise.resolve(),
			getActiveItemInfo: () => {
				return Promise.resolve({
					recipients: [
						{
							emailAddress: 'jonathan@cardy2.onmicrosoft.com',
							displayName: 'Jonathan Cardy',
							appointmentResponse: '',
							recipientType: '',
						},
					],
					subject: '00034',
				});
			},
			insertHTMLLink: (link) => {
				this.appendText(link);
			},
			insertFileAttachment: (name, uri) => {
				this.appendText(`Inserting attachment '${name}' from uri '${uri}'`);
			},
			useAsEmailTemplate: (to, subject, bodyHtml) => {
				this.appendText(
					`Using as email template to '${to.join(', ')}' with subject '${subject}' and body '${bodyHtml}'`
				);
			},
			replyInline: async (to, from, sent, subject, bodyHtml) => {
				this.appendText(
					`Replying inline to '${from}' with subject '${subject}' and body '${bodyHtml}'`
				);
				return Promise.resolve(true);
			},
			setCategory: (name: string, color: Office.MailboxEnums.CategoryColor) => Promise.resolve(),
			refreshFiledNotificationMessage: () => Promise.resolve(),
			addNotificationMessage: (name) => { },
			clearNotificationMessage: () => { },
			getMessageCustomProps: () => {
				return Promise.resolve({} as IEmailStoredFilingInfo);
			},
			setMessageCustomProps: (info: IEmailStoredFilingInfo) => Promise.resolve(),
			onMessageCustomPropsUpdated: (
				callback: (info: IEmailStoredFilingInfo) => void
			) => { },
			launchWindow: (url: string) => Promise.resolve(),
			setSendAndFileLocation: function (entityType: IEntityTypeUserInfo | undefined, entityId: string | null, url: string): Promise<void> {
				return Promise.resolve();
			}
		};

		this.mail = new MobileAttachmentsState(userConfig, commands);
	}

	public appendText(text: string): void {
		this.currentText += ' ' + text;
	}
}
